import { createContext, useState } from "react";
import { IFoundedAuctions } from "../interfaces/IfoundedAuctions";
interface IFoundedAuctionContext {
  foundedAuctions: IFoundedAuctions[];
  setFoundedAuctions: (values: IFoundedAuctions[]) => void;
}
const IDefaultValues = {
  foundedAuctions: [],
  setFoundedAuctions: () => {},
};
export const FoundedAuctionContext =
  createContext<IFoundedAuctionContext>(IDefaultValues);
export const FoundedAuctionsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [foundedAuctions, setFoundedAuctions] = useState<IFoundedAuctions[]>(
    []
  );
  return (
    <FoundedAuctionContext.Provider
      value={{
        foundedAuctions,
        setFoundedAuctions: (values) => setFoundedAuctions(values),
      }}
    >
      {children}
    </FoundedAuctionContext.Provider>
  );
};
